var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssetsBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uwnlplteyh",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dprrnlrwff",
    transform: "translate(-200.000000, -36.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "udhwnwrhcn",
    transform: "translate(200.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hushnwgwqf",
    transform: "translate(0.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tyizvsggqm",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tyudhjyfzk"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "vyzintloqt",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.853094,4 L13.4714922,4 C13.3775432,4 13.2891207,4.0390625 13.2338567,4.103125 L8.00034906,10.221875 L2.76684147,4.103125 C2.7115774,4.0390625 2.62315489,4 2.52920596,4 L1.14760417,4 C1.02786535,4 0.957864192,4.115625 1.02786535,4.1984375 L7.52323591,11.79375 C7.75902928,12.06875 8.24166884,12.06875 8.47562008,11.79375 L14.9709906,4.1984375 C15.0428339,4.115625 14.9728328,4 14.853094,4 Z",
    id: "bdmbqtegju",
    fill: "#464B53",
    transform: "translate(8.000000, 8.000000) rotate(90.000000) translate(-8.000000, -8.000000) "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetsBack);
export default __webpack_public_path__ + "static/media/assetsBack.95b664f568870fc7eafead494147eb7c.svg";
export { ForwardRef as ReactComponent };